import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { NoCacheHeaders } from "app/services/fetchService";

import type { LeadDomainsSearchResultsDto, LeadDomainsSearchResultsParams } from "../../types/dto";
import { leadsSearchQueryKeys } from "../key-factory/factory";

export function useCompanyDomainsQuery<T = LeadDomainsSearchResultsDto>(
    queryParams: LeadDomainsSearchResultsParams,
    select?: (data: LeadDomainsSearchResultsDto) => T,
): UseQueryResult<T> {
    return useQuery({
        queryKey: leadsSearchQueryKeys.companyDomains(queryParams),
        staleTime: Number.POSITIVE_INFINITY,
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        throwOnError: true,
        select,
        queryFn: ({ signal }): Promise<LeadDomainsSearchResultsDto> => {
            const { entityId, domain, dto } = queryParams;

            return salesApiService.leadsSearch.companies.fetchCompanyDomainsSearchResults(
                { entityId, domain, dto },
                {
                    headers: NoCacheHeaders,
                    cancellation: signal,
                },
            );
        },
    });
}
